
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:root{
--sic-cta--default--text-color:var(--color-primary-default);
--sic-cta--default--font-size:var(--body-helper-font-size);
--sic-cta--default--font-size--sm-locked:calc(var(--body-helper-min-font-size));
--sic-cta--default--font-size--lg:var(--body-01-font-size);
--sic-cta--default--line-height:var(--line-height-xl);
--sic-cta--default--family:var(--ff-body);
--sic-cta--default--weight:var(--fw-bold);
--sic-cta--default--padding:var(--spacing-01) 0;
--sic-cta--default--margin:0 var(--spacing-01) 0 0;
--sic-cta--default--radius:var(--border-radius-outline-default);
--sic-cta--default--border-color:var(--color-primary-default);
--sic-cta--default--border-width:var(--border-width-thicker);
--sic-cta--file-icon-size:var(--spacing-04);
--sic-cta--default--outline-width--focus:var(--border-width-thicker);
--sic-cta--default--outline-offset--focus:var(--border-width-thicker);
--sic-cta--default--text-color--disabled:var(--color-neutral-light);
}
`;